import * as React from 'react';

import classnames from 'classnames';

import {colors} from '../../colors/colors';
import {WarningIcon} from '../../icon/svg/warning-icon';

type Props = {
    linkText: string;
    isBold?: boolean;
    warningTooltip?: string;
};

export function LinkText(props: Props) {
    const classNames = classnames('font-size-small flex align-center flex-grow gap-8', {
        'font-bold': props.isBold,
    });

    return (
        <span className={classNames}>
            {props.linkText}
            {props.warningTooltip && (
                <WarningIcon
                    // @ts-expect-error
                    color={colors.yellow}
                    size={13}
                    data-tip={props.warningTooltip}
                    alignCenter={true}
                    wrapWithDiv={false}
                />
            )}
        </span>
    );
}
